<h2 mat-dialog-title>User Error Report</h2>
<mat-dialog-content>
  <p>{{ message }}</p>
  <div>
    <mat-form-field style="width: 540px; max-width: 65vw">
      <mat-label>Description</mat-label>
      <textarea #descriptionTextArea matInput [(ngModel)]="description" [required]="descriptionRequired"></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    [disabled]="descriptionRequired && !(description?.length > 0)"
    [mat-dialog-close]="this.result"
  ><mat-icon>send</mat-icon> Send Error Report</button>
  <button
    mat-raised-button
    [mat-dialog-close]="null">Cancel</button>
</mat-dialog-actions>
